const getDefaultState = () => {
  return {
    all: null
  };
};

export default {
  state: getDefaultState(),
  getters: {
    getAll(state) {
      return state.all;
    }
  },
  mutations: {
    /**
     * 初期化
     */
    init(state) {
      Object.assign(state, getDefaultState());
    },
    setAll(state, data) {
      state.all = data;
    }
  }
};
